import styled from 'styled-components';

export const TechnologySection = styled.section<{ $isVisible?: boolean }>`
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #0a0a0a 0%, #050505 100%);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  }

  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const TechGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

export const TechContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TechFeature = styled.div<{ $isVisible?: boolean; $delay?: number }>`
  display: flex;
  gap: 24px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  transition: all 0.3s ease;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: translateY(${props => props.$isVisible ? '0' : '20px'});
  transition-delay: ${props => props.$delay ? `${props.$delay}ms` : '0ms'};

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 68, 68, 0.2);
    transform: translateX(8px);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
`;

export const TechIcon = styled.div`
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255, 68, 68, 0.1), rgba(255, 68, 68, 0.05));
  border: 1px solid rgba(255, 68, 68, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff4444;

  svg {
    width: 28px;
    height: 28px;
  }

  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

export const TechText = styled.div`
  flex: 1;
`;

export const TechTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
`;

export const TechDescription = styled.p`
  font-size: 1rem;
  color: #a1a1aa;
  line-height: 1.6;
`;

export const TechVisual = styled.div<{ $isVisible?: boolean }>`
  position: relative;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: scale(${props => props.$isVisible ? 1 : 0.95});
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 1024px) {
    min-height: 300px;
  }
`;
